import { FC, useCallback, useEffect, useState } from 'react';
import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  useWindowDimensions,
  View,
} from 'react-native';
import { MAX_WIDTH } from '../../constants/platform';
import MyAccountMenu from '../../components/MyAccountMenu/MyAccountMenu';
import PageTitle from '../../components/PageTitle';
import { COLORS, FONTS } from '../../constants';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { Footer } from '../../components/Footer';
import { MyActivitiesDetailScreenProps } from './types';
import { IActivity, IMyActivity } from '../../types/activities.types';
import ActivityApi from '../../services/api/activity.api';
import { Loading } from '../../components';
import { isSameDate } from '../../services/utils/dateConvert';
import dayjs from 'dayjs';
import RenderHTML from 'react-native-render-html';
import { DATE_TYPE } from '../../constants/activity';
import { convertToAmPm } from '../../services/utils';

const MyActivitiesDetail: FC<MyActivitiesDetailScreenProps> = ({
  route,
  navigation,
}) => {
  const activityId = route.params.id;
  const isDesktop = useIsDesktop();

  const [activity, setActivity] = useState<IActivity>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { height: screenHeight } = useWindowDimensions();

  const getActivity = useCallback(async () => {
    setIsLoading(true);
    ActivityApi.getActivity(activityId)
      .then((res) => {
        setActivity(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [activityId]);

  useEffect(() => {
    getActivity();
  }, [getActivity]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: MAX_WIDTH,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            marginBottom: 200,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '22%', minWidth: 230, marginRight: 20 }}>
              <MyAccountMenu />
            </View>
            <View style={{ width: '70%' }}>
              <PageTitle title="My Activities" haveGoBackButton={true} />
              <View
                style={{
                  paddingHorizontal: 40,
                  paddingTop: 40,
                  backgroundColor: COLORS.LIGHT_RED,
                  borderRadius: 18,
                  flexDirection: 'column',
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  paddingBottom: 35,
                  elevation: 20,
                }}
              >
                {isLoading ? (
                  <Loading />
                ) : activity ? (
                  <View>
                    {/* <Text
                      style={{
                        fontFamily: FONTS.Arial,
                        fontWeight: '700',
                        fontSize: 20,
                        letterSpacing: 1.7,
                        color: COLORS.BLACK,
                        textTransform: 'uppercase',
                        borderBottomWidth: 1,
                        borderBottomColor: COLORS.GREY,
                        paddingBottom: 15,
                        marginBottom: 20,
                      }}
                    >
                      {activity.camp.name}
                    </Text> */}
                    <Image
                      source={
                        activity.image
                          ? {
                              uri: activity.image,
                            }
                          : require('../../assets/activities-image.png')
                      }
                      style={{
                        width: '100%',
                        height: 400,
                        borderRadius: 18,
                        marginBottom: 20,
                      }}
                    />
                    <View style={[{ flexDirection: 'row' }]}>
                      <View style={{ width: '20%' }}>
                        <Text
                          style={{
                            fontFamily: FONTS.AvenirMedium,
                            fontWeight: '800',
                            fontSize: 19,
                            letterSpacing: 1,
                            marginBottom: 10,
                            color: COLORS.BLACK,
                          }}
                        >
                          {activity?.name}
                        </Text>
                        <View
                          style={{
                            width: 58,
                            height: 2,
                            backgroundColor: COLORS.RED_PRIMARY,
                            marginBottom: 10,
                          }}
                        />
                        {activity.date_type.value === DATE_TYPE.NORMAL ? (
                          activity.start_date === activity.end_date ? (
                            <Text style={styles.textDesktop}>
                              {`${dayjs(activity.start_date).format(
                                'MMMM DD, YYYY'
                              )}`}
                            </Text>
                          ) : (
                            <>
                              <Text style={styles.textDesktop}>
                                {`Start: ${dayjs(activity.start_date).format(
                                  'MMMM DD, YYYY'
                                )}`}
                              </Text>
                              <Text style={styles.textDesktop}>
                                {`End: ${dayjs(activity.end_date).format(
                                  'MMMM DD, YYYY'
                                )}`}
                              </Text>
                            </>
                          )
                        ) : (
                          <Text style={styles.textDesktop}>
                            {activity.date_type.name}
                          </Text>
                        )}
                        <View
                          style={{
                            borderRadius: 18,
                            paddingVertical: 2,
                            paddingHorizontal: 15,
                            backgroundColor: COLORS.RED_PRIMARY,
                            width: 100,
                            marginBottom: 10,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: FONTS.AvenirMedium,
                              fontSize: 12,
                              fontWeight: '500',
                              color: COLORS.WHITE,
                              textAlign: 'center',
                              lineHeight: 18,
                            }}
                          >
                            {`${convertToAmPm(
                              activity.start_time
                            )} - ${convertToAmPm(activity.end_time)}`}
                          </Text>
                        </View>
                        <Text style={styles.textDesktop}>{activity.type}</Text>
                        <Text
                          style={{
                            fontFamily: FONTS.AvenirMedium,
                            fontWeight: '500',
                            fontSize: 14,
                            color: COLORS.GREY,
                            letterSpacing: 1,
                            marginBottom: 10,
                          }}
                        >
                          {activity.venue}
                        </Text>
                      </View>
                      <View style={{ width: '80%' }}>
                        <RenderHTML
                          source={{ html: activity.description }}
                          tagsStyles={{
                            body: {
                              fontFamily: FONTS.AvenirRegular,
                              fontSize: 18,
                              color: COLORS.BLACK,
                              fontWeight: '500',
                            },
                            p: {
                              marginTop: 0,
                              marginBottom: 10,
                            },
                          }}
                        />
                      </View>
                    </View>
                  </View>
                ) : (
                  <></>
                )}
              </View>
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <PageTitle title={'MY UPCOMING ACTIVITIES'} haveGoBackButton={true} />
      <View
        style={{
          paddingHorizontal: 30,
          paddingVertical: 30,
          backgroundColor: '#F9F1F1',
          minHeight: screenHeight * 0.8,
        }}
      >
        {isLoading ? (
          <Loading />
        ) : activity ? (
          <View>
            {/* <Text style={styles.campTitle}>{activity.camp.name}</Text> */}
            <View
              style={{ flexDirection: 'column', gap: 15, marginBottom: 15 }}
            >
              <Image
                source={
                  activity.image
                    ? {
                        uri: activity.image,
                      }
                    : require('../../assets/activities-image.png')
                }
                style={{
                  width: '100%',
                  height: 175,
                  borderRadius: 18,
                }}
              />
              <View
                style={{
                  flex: 1,
                }}
              >
                <Text
                  style={{
                    fontFamily: FONTS.AvenirMedium,
                    fontWeight: '800',
                    fontSize: 19,
                    letterSpacing: 1,
                    marginBottom: 10,
                    color: COLORS.BLACK,
                  }}
                >
                  {activity.name}
                </Text>
                <View
                  style={{
                    width: 58,
                    height: 2,
                    backgroundColor: COLORS.RED_PRIMARY,
                    marginBottom: 10,
                  }}
                />
                {activity.date_type.value === DATE_TYPE.NORMAL ? (
                  activity.start_date === activity.end_date ? (
                    <Text style={styles.text}>
                      {`${dayjs(activity.start_date).format('MMMM DD, YYYY')}`}
                    </Text>
                  ) : (
                    <>
                      <Text style={styles.text}>
                        {`Start: ${dayjs(activity.start_date).format(
                          'MMMM DD, YYYY'
                        )}`}
                      </Text>
                      <Text style={styles.text}>
                        {`End: ${dayjs(activity.end_date).format(
                          'MMMM DD, YYYY'
                        )}`}
                      </Text>
                    </>
                  )
                ) : (
                  <Text style={styles.text}>{activity.date_type.name}</Text>
                )}
                <View
                  style={{
                    borderRadius: 18,
                    paddingVertical: 2,
                    paddingHorizontal: 15,
                    backgroundColor: COLORS.RED_PRIMARY,
                    width: 100,
                    marginBottom: 10,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: FONTS.AvenirMedium,
                      fontSize: 12,
                      fontWeight: '500',
                      color: COLORS.WHITE,
                      textAlign: 'center',
                      lineHeight: 18,
                    }}
                  >
                    {`${convertToAmPm(activity.start_time)} - ${convertToAmPm(
                      activity.end_time
                    )}`}
                  </Text>
                </View>
                <Text style={styles.text}>{activity.type}</Text>

                <Text style={styles.text}>{activity?.venue}</Text>
              </View>
            </View>
            <RenderHTML
              source={{ html: activity.description }}
              tagsStyles={{
                body: {
                  fontFamily: FONTS.AvenirRegular,
                  fontSize: 16,
                  color: COLORS.BLACK,
                  fontWeight: '500',
                },
                p: {
                  marginTop: 0,
                  marginBottom: 10,
                },
              }}
            />
          </View>
        ) : (
          <></>
        )}
      </View>
      <Footer />
    </ScrollView>
  );
};

export default MyActivitiesDetail;

const styles = StyleSheet.create({
  campTitle: {
    fontFamily: FONTS.Arial,
    fontWeight: '700',
    fontSize: 20,
    letterSpacing: 1.7,
    color: COLORS.BLACK,
    textTransform: 'uppercase',
    borderBottomWidth: 1,
    borderBottomColor: COLORS.GREY,
    paddingBottom: 15,
    marginBottom: 20,
  },
  textDesktop: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 13,
    color: COLORS.GREY,
    letterSpacing: 1,
    marginBottom: 10,
  },
  text: {
    fontFamily: FONTS.AvenirRegular,
    fontSize: 16,
    color: COLORS.BLACK,
    fontWeight: '500',
    letterSpacing: 1,
    marginBottom: 10,
  },
  buttonStyle: {
    width: 230,
    paddingVertical: 10,
  },
  buttonTextStyle: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 19,
    fontWeight: '800',
    letterSpacing: 1,
  },
});
